import { createContext, useContext } from 'react';

import { usePersistState } from '../hooks/usePersistState';

const ThemeColorContext = createContext<any>(null);

export const ThemeColorProvider = ({ children }) => {
  const [themeColor, setThemeColor] = usePersistState(null, 'themeColor');

  return (
    <ThemeColorContext.Provider
      value={{
        themeColor,
        setThemeColor,
      }}
    >
      {children}
    </ThemeColorContext.Provider>
  );
};

export const useThemeColorContext = () => {
  return useContext(ThemeColorContext);
};
